/**
 * @param {import('./lightbox-store').LightboxStoreActionContext} context
 */
export function close(context) {
  context.commit('setIndex', null);
}

/**
 * @param {import('./lightbox-store').LightboxStoreActionContext} context
 * @param {{ items: string[]; index: number; }}
 */
export function openItems(context, { items = [], index = 0 }) {
  context.commit('setItems', items);
  context.commit('setIndex', index);
}

/**
 * @param {import('./lightbox-store').LightboxStoreActionContext} context
 */
export function prev(context) {
  let prevIndex = 0;
  if (!isNaN(context.state.index)) {
    prevIndex = context.state.index - 1;
  }
  if (prevIndex < 0) {
    prevIndex = context.state.items.length - 1;
  }
  context.commit('setIndex', prevIndex);
}

/**
 * @param {import('./lightbox-store').LightboxStoreActionContext} context
 */
export function next(context) {
  let nextIndex = 0;
  if (!isNaN(context.state.index)) {
    nextIndex = context.state.index + 1;
  }
  if (nextIndex >= context.state.items.length) {
    nextIndex = 0;
  }
  context.commit('setIndex', nextIndex);
}
